module.exports = __webpack_public_path__ + "static/media/front.605fb7c9.jpg";